import React from 'react';

const Settings2 = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" {...props}>
    <g clipPath="url(#clip0_58_4559)">
      <path
        d="M11 14.4375C12.8985 14.4375 14.4375 12.8985 14.4375 11C14.4375 9.10152 12.8985 7.5625 11 7.5625C9.10152 7.5625 7.5625 9.10152 7.5625 11C7.5625 12.8985 9.10152 14.4375 11 14.4375Z"
        stroke="#3F3C43"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.56034 15.3046C3.18047 14.6503 2.88945 13.9483 2.69495 13.2172L4.13698 11.4125C4.12065 11.1366 4.12065 10.86 4.13698 10.5841L2.69581 8.77938C2.88997 8.04812 3.1804 7.34589 3.55948 6.6911L5.85487 6.43329C6.03817 6.22678 6.23359 6.03135 6.4401 5.84805L6.69792 3.55352C7.35176 3.17625 8.05285 2.88755 8.78276 2.69501L10.5874 4.13704C10.8634 4.12071 11.14 4.12071 11.4159 4.13704L13.2206 2.69587C13.9518 2.89003 14.6541 3.18046 15.3089 3.55954L15.5667 5.85493C15.7732 6.03823 15.9686 6.23365 16.1519 6.44016L18.4464 6.69798C18.8263 7.35227 19.1173 8.05425 19.3118 8.7854L17.8698 10.5901C17.8861 10.866 17.8861 11.1426 17.8698 11.4185L19.311 13.2232C19.1182 13.9543 18.8292 14.6565 18.4516 15.3115L16.1562 15.5693C15.9729 15.7758 15.7775 15.9712 15.571 16.1545L15.3131 18.4491C14.6589 18.8289 13.9569 19.12 13.2257 19.3145L11.421 17.8724C11.1451 17.8888 10.8685 17.8888 10.5926 17.8724L8.78792 19.3136C8.05687 19.1208 7.35464 18.8318 6.69963 18.4542L6.44182 16.1588C6.23531 15.9755 6.03988 15.7801 5.85659 15.5736L3.56034 15.3046Z"
        stroke="#3F3C43"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_58_4559">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Settings2;
